import { IoMdClose } from 'react-icons/io';

const MembersList = ({ members = [], setMembers }) => {
  const handleDeleteMember = (indexToRemove) => {
    setMembers(members.filter((_, index) => index !== indexToRemove));
  };

  return (
    <div className="max-h-[170px] overflow-y-auto rounded-lg p-4 space-y-6">
      <div>
        <h3 className="text-lg font-semibold mb-3">Members</h3>
        {members.length > 0 ? (
          <ul className="space-y-3">
            {members.map((member, index) => (
              <li
                key={index}
                className="flex items-center justify-between"
              >
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 rounded-full bg-gray-300" />
                  <div>
                    <span className="font-medium text-gray-800">
                      {member.first_name + " " + member.last_name}
                    </span>
                    <p className="text-sm text-gray-500">{member.email}</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <span className="text-sm text-gray-700">{member.role}</span>
                  {member.role !== 'Company Head' && (
                    <button
                      onClick={() => handleDeleteMember(index)}
                      className="text-red-500 hover:text-red-700 transition-colors"
                      aria-label={`Remove ${member.name}`}
                    >
                      remove
                    </button>
                  )}
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-sm text-gray-500">No members added yet.</p>
        )}
      </div>
    </div>
  );
};

export default MembersList;